import { Component, OnInit, Renderer2 } from '@angular/core';
import {
  Router, Event as RouterEvent, NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouterOutlet
} from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { timer } from 'rxjs';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { Environment } from 'src/environments/environment';
import { cilListNumbered, cilPaperPlane, brandSet } from '@coreui/icons';
import { AuthSignalRService } from '../app/signalr/auth.signalr.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet>       
    <div
  *ngIf='showLoader'
  class="fade show"
  style="
    text-align: center;
    padding-top: calc(100vh / 2);
    height: 100vh;
    width: 100%;
    background-color: #085d66;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  "
>
  <!-- <i class="spinner-grow spinner-grow-sm"></i>
<span class="m-1">Loading...</span> -->

  <div class="indicator">
    <svg width="16px" height="12px">
      <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
      <polyline
        id="front"
        points="1 6 4 6 6 11 10 1 12 6 15 6"
      ></polyline>
    </svg>
  </div>

  <span class="loading-txt">Loading...</span>

  <!--
   <img src="" alt=""> -->
</div>   
</router-outlet>`,
})
export class AppComponent implements OnInit {
  title = 'Tableegh Portal';

  showLoader: boolean = false;


  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private spinner: NgxSpinnerService,
    public iconSet:IconSetService,
    private signalR: AuthSignalRService

  ) {
    iconSet.icons={cilListNumbered,cilPaperPlane,...brandSet};
    // console.log(JSON.stringify(Environment))
    titleService.setTitle(this.title);
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
    this.router.events.subscribe(event => {
      if(event instanceof NavigationStart){
          this.showLoader = true;
      } else if(event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError){
        setTimeout(() => {
          this.showLoader = false
        }, 1000);
      }
    })
  }



  ngOnInit() {
    // this.signalR.startConnection()
    // this.spinner.show();
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 2000);
  }
  // showSpinner() {
  //   this.spinner.show();
  //   setTimeout(() => {
  //     this.spinner.hide();
  //   }, 3000);
  // }
}
